import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

class GoogleMap extends Component {

	constructor(props) {
		super(props);

		this.state = {
			gmap: {},
			map: {},
			markers: [],
			marker: {}
		}
	}

	createMarker(GMap, map, data) {
		const { title, content, latitude, longitude } = data;
		const marker_content = new GMap.InfoWindow({
	    	content: `<h3>${title}</h3>${content}`,
	    });

		const marker = new GMap.Marker({
			position: {lat: latitude, lng: longitude},
			map: map,
			title: title
		});

		marker.addListener('click', function() {
			marker_content.open(map, marker);
		});
	}


	componentDidMount() {
    if(!window.google) {
      return;
    }

    var GMap = window.google.maps;

    var map = new GMap.Map(this.refs.map, {
      center: {lat: 57.397, lng: -100.644},
      zoom: 3.6
    });

    const { markers } = this.props;

    markers.forEach(marker => {
      const { title, latitude, longitude } = marker.node.frontmatter;

      const newMarkerDatas = {
        title: title,
        content: marker.node.html,
        latitude: Number(latitude),
        longitude: Number(longitude), 
      };

      this.createMarker(GMap, map, newMarkerDatas);
    });
	}

	render() {
		const mapStyle = {
			height: 400,
			border: '1px solid black'
		};

		return (
			<div id="map-container">
				<div ref="map" style={mapStyle} />
			</div>
		);
	}
}

GoogleMap.propTypes = {
    markers: PropTypes.array,
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/GoogleMap.jsx